<app-header></app-header>
<app-prices></app-prices>
<app-questions></app-questions>
<app-footer></app-footer>
